import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Typography,
  Button,
  List,
  ListItem,
  Stack,
  Card,
} from "@mui/material";

const API = "https://course-selling-backend-2-rr1n.onrender.com";

function CourseDetails() {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);

  // ✅ Google Drive Embed URL Generator
  const getEmbedUrl = (url) => {
    try {
      if (url.includes("drive.google.com")) {
        // Convert any type of Google Drive link into preview format
        const fileIdMatch = url.match(/\/d\/(.*?)\//);
        const fileIdParam = url.match(/id=([^&]+)/);
        const fileId = fileIdMatch ? fileIdMatch[1] : fileIdParam ? fileIdParam[1] : null;

        if (fileId) {
          return `https://drive.google.com/file/d/${fileId}/preview`;
        }
        return url.replace("/view", "/preview");
      }
      return url;
    } catch {
      return url;
    }
  };

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API}/api/courses/${id}`, {
          headers: { "x-auth-token": token },
        });
        setCourse(res.data);

        // Auto-select first video
        if (res.data.videos?.length > 0) {
          setSelectedVideo(getEmbedUrl(res.data.videos[0]));
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchCourse();
  }, [id]);

  if (!course) {
    return <Typography align="center">Loading course...</Typography>;
  }

  return (
    <Box sx={{ p: 4, maxWidth: "1000px", mx: "auto" }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        {course.title}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        {course.description}
      </Typography>

      {/* 🎬 Google Drive Video Player */}
      {selectedVideo && (
        <Card
          sx={{
            mb: 4,
            overflow: "hidden",
            borderRadius: "12px",
            boxShadow: 3,
          }}
        >
          <Box
            sx={{
              position: "relative",
              paddingTop: "56.25%", // 16:9 ratio
            }}
          >
            <iframe
              src={selectedVideo}
              title="Course Video"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: 0,
              }}
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          </Box>
        </Card>
      )}

      {/* 📚 Video List */}
      <Typography variant="h6" gutterBottom>
        🎥 Course Videos
      </Typography>
      <List>
        {course.videos.map((video, index) => (
          <ListItem key={index}>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography>Video {index + 1}</Typography>
              <Button
                variant="contained"
                size="small"
                onClick={() => setSelectedVideo(getEmbedUrl(video))}
              >
                Watch
              </Button>
            </Stack>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default CourseDetails;
